import React from "react";

import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Header from "./client/components/header.jsx";
import Footer from "./client/components/footer.jsx";
 
import LoginContainer from "./client/components/login/login.jsx";
import SearchPatient from "./client/components/login/searchPatient.jsx";

import LogoutContainer from "./client/components/login/logout.jsx";
import LoginAdminContainer from "./client/components/login/login-asesor.jsx";
import LoginAdminContainerV2 from "./client/components/login/login-asesor-v2.jsx";


import Register from "./client/components/register/register.jsx";
import ForgotPassword from "./client/components/forgot-password";
import Home from "./client/components/home/index";
import HomeEcom from "./client/components/home-ecom/index";
import HomePlans from "./client/components/home-plans/index";

import Searchdoctor from //"./client/components/home-plans/index";
"./client/components/pages/searchdoctor/searchList/index.jsx";
import Searchdoctor2 from "./client/components/home-plans/index";
//"./client/components/pages/searchdoctor/index.jsx";

import HomeReservas from "./client/components/home-reservas/index";

import HomeServices from "./client/components/home-services/index";
import OldBooking from "./client/components/patients/booking/OLDindex.jsx";
import Booking from "./client/components/patients/booking/index.jsx";
import Booking2 from "./client/components/patients/booking/index2.jsx";

import Booking3 from "./client/components/patients/booking/index3.jsx";
import Terms from "./client/components/pages/terms/index.jsx";
import Reservation from "./client/components/reservation/index";
import Mypatient from "./client/components/doctors/mypatient/index";

import Favourites from "./client/components/patients/adminDashboard/favourties/index";

import BookingSuccess from "./client/components/patients/booking-success/index.jsx";
import BookingError from "./client/components/patients/booking-error/index.jsx";
import BookingTimeOUT from "./client/components/patients/booking-timeout/index.jsx";
import Checkout from "./client/components/patients/checkout/index.jsx";
import Dashboard from "./client/components/patients/dashboard/index.jsx";

import DashboardD from  "./client/components/doctors/patientprofile/index.jsx";
import addpescription from  "./client/components/doctors/addpescription/index.jsx";
import addbilling from  "./client/components/doctors/addbilling/index.jsx";


import AdminDashboard from "./client/components/patients/adminDashboard/index.jsx";
import manageUsers from "./client/components/patients/manageUsers/index.jsx";

import managePatients from "./client/components/patients/managePatients/index.jsx";

import manageServices from "./client/components/patients/manageServices/index.jsx";
import manageRules from "./client/components/patients/manageRules/index.jsx";

//import calender from "./client/components/pages/calender/index.jsx";

// import Home1 from "./client/components/home/home1";
// import Home2 from "./client/components/home/home2";
// import HomeSlider1 from "./client/components/home/homeslider1";
// import HomeSlider2 from "./client/components/home/homeslider2";
 

const AppContainer = function (props) {
  if (props) {
    const url = props.location.pathname.split("/")[1];

    return (
      <Router>
        {
        url === "admin" ? (
          <div>
            
          </div>
        ) :
        (
          <div>
            {/* { url === "homeslider1" && <Route render={(props)=> <TopHeader {...props}/>} />} */}
            <Route render={(props) => <Header {...props} />} />
            <Switch>
             
              <Route path="/login" exact component={LoginContainer} />
              <Route path="/search-patient" exact component={SearchPatient} />
              
              <Route path="/logout" exact component={LogoutContainer} />

              <Route path="/logouttablet" exact component={LogoutContainer} />
              
              <Route path="/login-asesor" exact component={LoginAdminContainer} />
              <Route path="/login-monitor" exact component={LoginAdminContainerV2} />
              <Route path="/loginm" exact component={LoginAdminContainerV2} />

              <Route path="/login-innova" exact component={LoginAdminContainer} />
              <Route path="/register" exact component={Register} />
              <Route path="/forgot-password" exact component={ForgotPassword} />
              <Route path="(/|/home)" exact component={Home} />	
              
              <Route path="/terms" exact component={Terms} />
              
              <Route path="(/HomeEcom)" exact component={HomeEcom} />	
              <Route path="(/HomePlans)" exact component={HomePlans} />	
              <Route path="(/HomeReservas)" exact component={HomeReservas} />	

              <Route path="(/searchdoctor)" exact component={Searchdoctor} />	
              <Route path="(/searchdoctor2)" exact component={Searchdoctor2} />	

              
              

              
              <Route path="(/reservation)" exact component={Reservation} />	

              <Route path="(/doctor-dashboard)" exact component={Reservation} />	
              

              
              <Route path="(/HomeServices)" exact component={HomeServices} />	
              
              <Route path="(/salesDashboard)" exact component={AdminDashboard} />         
              <Route path="(/manageUsers)"    exact component={manageUsers} />         

              <Route path="(/managePatients)"    exact component={managePatients} />         

              <Route path="(/manageServices)"    exact component={manageServices} />         
              <Route path="(/manageRules)"    exact component={manageRules} />         
              {/*<Route path="(/calender)"    exact component={calender} />   */}
              
              {/* pages */}

                
             
              <Route exact path="/patient/booking-old/:serviceType/:productId/:token"  component={OldBooking} />
              <Route exact path="/patient/booking-old/:serviceType/:productId"  component={OldBooking} />

              <Route exact path="/patient/booking/:serviceType/:serviceId/:customerCI"  component={Booking} />
              <Route exact path="/patient/booking/:serviceType/:serviceId/:customerCI/:planCode"  component={Booking} />
              <Route exact path="/patient/booking/:serviceType/:serviceId/:customerCI/:planCode/:forcedKey"  component={Booking} />
               


              <Route exact path="/patient/appoiments"  component={Booking2} />
              <Route exact path="/patient-reservations"  component={Booking3} />
            
              <Route exact path="/patient/booking2/:serviceType/:serviceId/:customerCI"  component={Booking2} />
              <Route exact path="/patient/booking2/:serviceType/:serviceId/:customerCI/:planCode"  component={Booking2} />
              <Route exact path="/patient/booking2/:serviceType/:serviceId/:customerCI/:planCode/:forcedKey"  component={Booking2} />
             
              <Route path="/patient/checkout" exact component={Checkout} />
              
               <Route path="/patient/checkout/:productType/:Id" component={Checkout} />
               
              <Route
                path="/patient/booking-success/:productType/:productCode"
                exact
                component={BookingSuccess}
              />

<Route
                path="/patient/booking-success/:productType"
                exact
                component={BookingSuccess}
              />
              
              <Route
                path="/patient/booking-error/:productType"
                exact
                component={BookingError}
              />
              <Route
                path="/patient/booking-timeout/:productType"
                exact
                component={BookingTimeOUT}
              />
              
               
              <Route path="/patient/dashboard/:customerDocumentId/" exact component={Dashboard} /> 
               
              <Route path="/patient/reservations/:customerDocumentId" exact component={DashboardD} /> 
             
              <Route path="/patient/favourites" exact component={Favourites} /> 

              <Route path="/patient/my-patient" exact component={Mypatient} /> 
              <Route path="/patient/profile/:customerDocumentId" exact component={DashboardD} /> 
              <Route path="/add-prescription" exact component={addpescription} /> 
              <Route path="/add-billing" exact component={addbilling} /> 
             
            </Switch>
            <Route render={(props) => <Footer {...props} />} />
          </div>
        )}
      </Router>
    );
  }
  return null;
};

export default AppContainer;